import React from 'react';
import styles from './ReferenceNumberPopup.module.scss';
import PageLink from 'components/PageLink/PageLink';
import { OpenChatBot } from 'utils/chatBot';
import classNames from 'classnames/bind';
interface Props {
  Model?: any;
  PageData?: any;
  handleClick: Function;
}

const ReferenceNumberPopup = ({ Model, PageData, handleClick }: Props) => {
  const liveBtn = () => {
    // OpenChatBot;
    OpenChatBot(Model?.WebchatPageUrl, PageData?.AnyQuestionsButtonText);
  };
  return (
    <div className="modal-content">
      <div className="Modal_wrapper u-center">
        <button
          type="button"
          className="modal-close"
          onClick={() => handleClick(false)}
        ></button>
        <div className={styles.Heading}>{PageData?.ReferenceTooltipTitle}</div>
        <div className={styles.content}>{PageData?.ReferenceTooltipText}</div>
        

        <button
          type="button"
          className="Button w-100"
          onClick={() => handleClick(false)}
        >
          {PageData?.OkayGotItLabel}
        </button>
      </div>
    </div>
  );
};

export default ReferenceNumberPopup;
